module.exports = "/images/payment_methods_gpay_applepay_card.png?5ec86bdf92e46ee68523d24f8d69f7d4";